export default __webpack_public_path__ + "static/acq-category-4-61234676f38ff1fda9ab4bacb5876ce9.jpg";